'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SearchEmpty = function SearchEmpty() {
  return React__default["default"].createElement("svg", {
    width: "627",
    height: "338",
    viewBox: "0 0 627 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter0_f)"
  }, React__default["default"].createElement("path", {
    d: "M329.43 314H278.381C277.576 314 276.85 314.483 276.537 315.224L273.169 323.224C272.614 324.542 273.582 326 275.012 326H312.421H332.939C334.382 326 335.35 324.518 334.77 323.197L331.262 315.197C330.943 314.47 330.224 314 329.43 314Z",
    fill: "#00314A"
  })), React__default["default"].createElement("mask", {
    fill: "white"
  }, React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.132 118.536V86.2506C329.132 83.0541 332.82 80.9427 335.581 82.5534C344.996 88.0453 356 96.8028 356 131.67C356 149.843 342.947 161.133 328.826 167.149V296.878C328.826 310.758 317.574 322.01 303.694 322.01C289.814 322.01 278.562 310.758 278.562 296.878V167.158C264.78 161.07 252 149.647 252 131.67C252 97.2601 263.062 88.2795 272.262 82.7712C275.046 81.104 278.868 83.2589 278.868 86.5043V118.527C278.868 120.01 279.693 121.382 281.003 122.075L302.138 133.247C303.308 133.866 304.692 133.866 305.862 133.247L326.997 122.075C328.307 121.382 329.132 120.019 329.132 118.536ZM303.695 311.286C311.771 311.286 318.318 304.885 318.318 296.988C318.318 289.092 311.771 282.69 303.695 282.69C295.62 282.69 289.073 289.092 289.073 296.988C289.073 304.885 295.62 311.286 303.695 311.286Z"
  })), React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.132 118.536V86.2506C329.132 83.0541 332.82 80.9427 335.581 82.5534C344.996 88.0453 356 96.8028 356 131.67C356 149.843 342.947 161.133 328.826 167.149V296.878C328.826 310.758 317.574 322.01 303.694 322.01C289.814 322.01 278.562 310.758 278.562 296.878V167.158C264.78 161.07 252 149.647 252 131.67C252 97.2601 263.062 88.2795 272.262 82.7712C275.046 81.104 278.868 83.2589 278.868 86.5043V118.527C278.868 120.01 279.693 121.382 281.003 122.075L302.138 133.247C303.308 133.866 304.692 133.866 305.862 133.247L326.997 122.075C328.307 121.382 329.132 120.019 329.132 118.536ZM303.695 311.286C311.771 311.286 318.318 304.885 318.318 296.988C318.318 289.092 311.771 282.69 303.695 282.69C295.62 282.69 289.073 289.092 289.073 296.988C289.073 304.885 295.62 311.286 303.695 311.286Z",
    fill: "#EDF6FE"
  }), React__default["default"].createElement("path", {
    d: "M335.581 82.5534L336.589 80.8258V80.8258L335.581 82.5534ZM328.826 167.149L328.042 165.309L326.826 165.827V167.149H328.826ZM278.562 167.158H280.562V165.855L279.371 165.328L278.562 167.158ZM272.262 82.7712L271.234 81.0553L271.234 81.0553L272.262 82.7712ZM281.003 122.075L281.938 120.307H281.938L281.003 122.075ZM302.138 133.247L303.073 131.479V131.479L302.138 133.247ZM305.862 133.247L304.927 131.479V131.479L305.862 133.247ZM326.997 122.075L326.062 120.307H326.062L326.997 122.075ZM327.132 86.2506V118.536H331.132V86.2506H327.132ZM336.589 80.8258C332.5 78.4402 327.132 81.5048 327.132 86.2506H331.132C331.132 84.6033 333.141 83.4452 334.574 84.2809L336.589 80.8258ZM358 131.67C358 114.049 355.223 102.775 351.079 95.1416C346.902 87.4487 341.443 83.6572 336.589 80.8258L334.574 84.2809C339.134 86.9414 343.885 90.2747 347.563 97.0502C351.275 103.885 354 114.423 354 131.67H358ZM329.61 168.989C344.062 162.831 358 151.009 358 131.67H354C354 148.677 341.831 159.434 328.042 165.309L329.61 168.989ZM330.826 296.878V167.149H326.826V296.878H330.826ZM303.694 324.01C318.679 324.01 330.826 311.862 330.826 296.878H326.826C326.826 309.653 316.47 320.01 303.694 320.01V324.01ZM276.562 296.878C276.562 311.862 288.71 324.01 303.694 324.01V320.01C290.919 320.01 280.562 309.653 280.562 296.878H276.562ZM276.562 167.158V296.878H280.562V167.158H276.562ZM250 131.67C250 150.786 263.629 162.748 277.754 168.987L279.371 165.328C265.93 159.391 254 148.508 254 131.67H250ZM271.234 81.0553C266.487 83.8975 261.08 87.748 256.922 95.4305C252.794 103.059 250 114.271 250 131.67H254C254 114.659 256.737 104.176 260.44 97.3344C264.113 90.5471 268.836 87.1532 273.289 84.4871L271.234 81.0553ZM280.868 86.5043C280.868 81.6962 275.344 78.5945 271.234 81.0553L273.289 84.4871C274.748 83.6135 276.868 84.8216 276.868 86.5043H280.868ZM280.868 118.527V86.5043H276.868V118.527H280.868ZM281.938 120.307C281.285 119.961 280.868 119.271 280.868 118.527H276.868C276.868 120.749 278.101 122.803 280.069 123.843L281.938 120.307ZM303.073 131.479L281.938 120.307L280.069 123.843L301.204 135.015L303.073 131.479ZM304.927 131.479C304.342 131.788 303.658 131.788 303.073 131.479L301.204 135.015C302.958 135.943 305.042 135.943 306.796 135.015L304.927 131.479ZM326.062 120.307L304.927 131.479L306.796 135.015L327.931 123.843L326.062 120.307ZM327.132 118.536C327.132 119.275 326.72 119.959 326.062 120.307L327.931 123.843C329.895 122.805 331.132 120.763 331.132 118.536H327.132ZM316.318 296.988C316.318 303.738 310.709 309.286 303.695 309.286V313.286C312.833 313.286 320.318 306.031 320.318 296.988H316.318ZM303.695 284.69C310.709 284.69 316.318 290.238 316.318 296.988H320.318C320.318 287.945 312.833 280.69 303.695 280.69V284.69ZM291.073 296.988C291.073 290.238 296.682 284.69 303.695 284.69V280.69C294.558 280.69 287.073 287.945 287.073 296.988H291.073ZM303.695 309.286C296.682 309.286 291.073 303.738 291.073 296.988H287.073C287.073 306.031 294.558 313.286 303.695 313.286V309.286Z",
    fill: "#0069C0",
    mask: "url(#path-2-inside-1)"
  }), React__default["default"].createElement("rect", {
    x: "304.254",
    y: "143.555",
    width: "32",
    height: "4",
    rx: "2",
    transform: "rotate(-152 304.254 143.555)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "331.131",
    y: "128.532",
    width: "32",
    height: "4",
    rx: "2",
    transform: "rotate(152 331.131 128.532)",
    fill: "#9EC6E7"
  }), React__default["default"].createElement("rect", {
    x: "277",
    y: "185",
    width: "54",
    height: "78",
    rx: "3",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("rect", {
    x: "320",
    y: "256",
    width: "32",
    height: "6",
    rx: "3",
    transform: "rotate(-90 320 256)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "280",
    y: "256",
    width: "64",
    height: "4",
    rx: "2",
    transform: "rotate(-90 280 256)",
    fill: "white"
  }), React__default["default"].createElement("path", {
    d: "M299.516 163.67C286.038 163.732 259.516 154.413 259.516 131.67",
    stroke: "#3387CD",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M322.5 295C322.5 306.046 314.546 315.2 303.5 315.2C292.454 315.2 285 306.046 285 295",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter1_f)"
  }, React__default["default"].createElement("path", {
    d: "M455.875 282H383.859C383.28 282 382.729 282.251 382.349 282.689L378.876 286.689C377.751 287.984 378.671 290 380.386 290H431.579H459.494C461.228 290 462.14 287.944 460.977 286.659L457.359 282.659C456.979 282.239 456.441 282 455.875 282Z",
    fill: "#00314A"
  })), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter2_f)"
  }, React__default["default"].createElement("path", {
    d: "M609.659 282H558.155C557.469 282 556.83 282.352 556.464 282.932L553.938 286.932C553.097 288.264 554.054 290 555.629 290H592.421H612.29C613.882 290 614.836 288.231 613.961 286.901L611.329 282.901C610.96 282.339 610.332 282 609.659 282Z",
    fill: "#00314A"
  })), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter3_f)"
  }, React__default["default"].createElement("path", {
    d: "M543.634 282H472.1C471.387 282 470.727 282.381 470.37 282.998L465.738 290.998C464.966 292.332 465.928 294 467.469 294H519.579H548.458C550.015 294 550.975 292.3 550.171 290.967L545.346 282.967C544.984 282.367 544.335 282 543.634 282Z",
    fill: "#00314A"
  })), React__default["default"].createElement("path", {
    d: "M490 150.023C483.666 150.312 478.81 153.348 475.399 158.024C470.946 148.953 460.511 125.002 451.638 98.6808C447.087 85.1792 452.564 74.3201 461.47 66.1105C469.972 58.2737 481.502 52.9689 490 50.3424V150.023Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M486 58.0002C472.767 61.8002 450.097 76.7202 457.288 98.0002",
    stroke: "white",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M471.988 161.378C469.071 167.007 469.273 172.731 471.617 178.023C461.535 177.343 435.575 174.406 408.344 168.929C394.375 166.119 387.709 155.947 385.053 144.129C382.517 132.847 383.688 120.21 385.662 111.537L471.988 161.378Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M473.988 182.855C477.405 188.196 482.463 190.884 488.218 191.499C482.588 199.891 467.064 220.904 448.706 241.748C439.288 252.44 427.146 253.127 415.583 249.519C404.545 246.074 394.186 238.741 387.662 232.695L473.988 182.855Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M492 191.978C498.334 191.689 503.19 188.653 506.601 183.976C511.054 193.048 521.489 216.998 530.362 243.32C534.913 256.821 529.436 267.68 520.53 275.89C512.028 283.727 500.498 289.032 492 291.658V191.978Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M510.33 179.005C513.247 173.375 513.046 167.651 510.702 162.359C520.784 163.039 546.744 165.977 573.975 171.453C587.943 174.263 594.609 184.435 597.265 196.253C599.801 207.535 598.63 220.172 596.656 228.845L510.33 179.005Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M508.328 158.526C504.911 153.186 499.854 150.498 494.098 149.882C499.728 141.49 515.252 120.477 533.611 99.6331C543.028 88.9409 555.171 88.2542 566.734 91.8627C577.771 95.3074 588.13 102.64 594.654 108.686L508.328 158.526Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("circle", {
    cx: "491",
    cy: "170",
    r: "22",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "4"
  }), React__default["default"].createElement("path", {
    d: "M416.811 207.172C411.259 197.529 408.268 186.7 408.116 175.797",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M431.258 199.148C427.473 192.854 425.357 185.83 425.109 178.797",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M403.138 213.958C395.819 200.965 391.953 186.331 391.898 171.559",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M559.822 216.191C553.913 225.62 545.756 233.345 536.201 238.598",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M545.954 207.202C542.173 213.499 536.965 218.665 530.872 222.186",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M572.232 225.078C564.196 237.64 553.09 247.923 540.073 254.908",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M496.894 86.9274C508.014 87.3298 518.782 90.5317 528.109 96.18",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M496.042 103.432C503.386 103.557 510.464 105.485 516.56 109.001",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M498.385 71.7361C513.282 72.4152 527.74 76.8914 540.298 84.6721",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M510 170C510 159.507 501.493 151 491 151C480.507 151 472 159.507 472 170",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M473 170C473 179.941 481.059 188 491 188C500.941 188 509 179.941 509 170",
    stroke: "#3387CD",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("rect", {
    x: "485.832",
    y: "145.217",
    width: "68",
    height: "2",
    rx: "1",
    transform: "rotate(-90 485.832 145.217)",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "466.89",
    y: "163.733",
    width: "68",
    height: "2",
    rx: "1",
    transform: "rotate(-150 466.89 163.733)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "573.89",
    y: "211.733",
    width: "68",
    height: "2",
    rx: "1",
    transform: "rotate(-150 573.89 211.733)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "473.891",
    y: "188.733",
    width: "68",
    height: "2",
    rx: "1",
    transform: "rotate(150 473.891 188.733)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "568.891",
    y: "119.733",
    width: "68",
    height: "2",
    rx: "1",
    transform: "rotate(150 568.891 119.733)",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "494.832",
    y: "263.217",
    width: "68",
    height: "2",
    rx: "1",
    transform: "rotate(-90 494.832 263.217)",
    fill: "white"
  }), React__default["default"].createElement("path", {
    d: "M497 284C510.233 280.2 532.903 265.28 525.712 244",
    stroke: "#3387CD",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M591.842 221.03C595.168 207.669 593.582 180.577 571.557 176.165",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M390.158 118.971C386.832 132.331 388.418 159.424 410.443 163.836",
    stroke: "white",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M398.114 231.97C408.021 241.53 432.277 253.703 447.111 236.835",
    stroke: "#C2DBF0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("circle", {
    cx: "491",
    cy: "170",
    r: "8",
    fill: "#3387CD"
  }), React__default["default"].createElement("path", {
    d: "M497 170C497 173.314 494.314 176 491 176C487.686 176 485 173.314 485 170",
    stroke: "#0069C0",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("circle", {
    cx: "491",
    cy: "170",
    r: "5",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("circle", {
    cx: "491",
    cy: "169",
    r: "4",
    fill: "white"
  }), React__default["default"].createElement("path", {
    d: "M585.798 109.029C575.89 99.4683 551.634 87.296 536.801 104.164",
    stroke: "white",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter4_f)"
  }, React__default["default"].createElement("path", {
    d: "M89.8755 294H17.8594C17.2801 294 16.7292 294.251 16.3493 294.689L12.8757 298.689C11.7513 299.984 12.6709 302 14.3857 302H65.5789H93.4939C95.2278 302 96.1403 299.944 94.9771 298.659L91.3587 294.659C90.9795 294.239 90.4407 294 89.8755 294Z",
    fill: "#00314A"
  })), React__default["default"].createElement("g", {
    opacity: "0.24",
    filter: "url(#filter5_f)"
  }, React__default["default"].createElement("path", {
    d: "M207.187 294H108.443C107.831 294 107.252 294.281 106.873 294.761L100.557 302.761C99.5219 304.073 100.456 306 102.127 306H173.789H213.766C215.455 306 216.384 304.035 215.311 302.73L208.732 294.73C208.352 294.268 207.785 294 207.187 294Z",
    fill: "#00314A"
  })), React__default["default"].createElement("rect", {
    x: "13",
    y: "63.0002",
    width: "102",
    height: "38",
    rx: "3",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M25 101H103V160C103 161.657 101.657 163 100 163H28C26.3431 163 25 161.657 25 160V101Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M22 151H106V140C106 138.343 104.657 137 103 137H25C23.3431 137 22 138.343 22 140V151Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("rect", {
    x: "105",
    y: "263",
    width: "102",
    height: "38",
    rx: "3",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M117 263H195V204C195 202.343 193.657 201 192 201H120C118.343 201 117 202.343 117 204V263Z",
    fill: "#EDF6FE",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M25 151H164C181.121 151 195 164.879 195 182V213H56C38.8792 213 25 199.121 25 182V151Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M114 213H198V224C198 225.657 196.657 227 195 227H117C115.343 227 114 225.657 114 224V213Z",
    fill: "#C2DBF0",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("rect", {
    x: "18",
    y: "66.0002",
    width: "64",
    height: "4",
    rx: "2",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "94",
    y: "84.0005",
    width: "24",
    height: "2",
    rx: "1",
    transform: "rotate(-45 94 84.0005)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "102",
    y: "81.6577",
    width: "8",
    height: "2",
    rx: "1",
    transform: "rotate(-45 102 81.6577)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "95",
    y: "77.0005",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(-45 95 77.0005)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "108",
    y: "297",
    width: "24",
    height: "2",
    rx: "1",
    transform: "rotate(-45 108 297)",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "116",
    y: "294.658",
    width: "8",
    height: "2",
    rx: "1",
    transform: "rotate(-45 116 294.658)",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "109",
    y: "290",
    width: "16",
    height: "2",
    rx: "1",
    transform: "rotate(-45 109 290)",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "34",
    y: "138",
    width: "64",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "164",
    y: "214",
    width: "32",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "123",
    y: "153",
    width: "40",
    height: "4",
    rx: "2",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "52",
    y: "206",
    width: "96",
    height: "6",
    rx: "3",
    fill: "#3387CD"
  }), React__default["default"].createElement("rect", {
    x: "25",
    y: "90.0002",
    width: "80",
    height: "6",
    rx: "3",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "132",
    y: "292",
    width: "64",
    height: "6",
    rx: "3",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("rect", {
    x: "124",
    y: "266",
    width: "80",
    height: "2",
    rx: "1",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "23.7502",
    height: "1.97918",
    rx: "0.989591",
    transform: "matrix(0.69959 -0.714545 0.69959 0.714545 162 184.314)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "7.91672",
    height: "1.97918",
    rx: "0.989591",
    transform: "matrix(0.69959 -0.714545 0.69959 0.714545 169.833 181.971)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    width: "15.8334",
    height: "1.97918",
    rx: "0.989591",
    transform: "matrix(0.69959 -0.714545 0.69959 0.714545 162.979 177.314)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "358.149",
    y: "164.049",
    width: "14",
    height: "78",
    transform: "rotate(-45 358.149 164.049)",
    fill: "#93C0E4",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("circle", {
    cx: "317.137",
    cy: "113.137",
    r: "72",
    transform: "rotate(-45 317.137 113.137)",
    stroke: "#3387CD",
    strokeWidth: "16"
  }), React__default["default"].createElement("path", {
    d: "M263.154 168.291C232.693 137.83 232.693 88.4435 263.154 57.9826",
    stroke: "#C2DBF0",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("circle", {
    cx: "317.137",
    cy: "113.137",
    r: "63",
    transform: "rotate(-45 317.137 113.137)",
    fill: "#2196F3",
    fillOpacity: "0.1",
    stroke: "#0069C0",
    strokeWidth: "2"
  }), React__default["default"].createElement("path", {
    d: "M277.539 152.735C255.67 130.866 255.67 95.4083 277.539 73.539",
    stroke: "white",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React__default["default"].createElement("path", {
    d: "M458.559 254.558C453.872 259.245 446.274 259.245 441.588 254.558L383.605 196.576C382.824 195.794 382.824 194.528 383.605 193.747L397.747 179.605C398.528 178.824 399.795 178.824 400.576 179.605L458.559 237.588C463.245 242.274 463.245 249.872 458.559 254.558Z",
    fill: "#0069C0"
  }), React__default["default"].createElement("path", {
    d: "M458.559 254.558C453.872 259.245 446.274 259.245 441.588 254.558L383.605 196.576C382.824 195.794 382.824 194.528 383.605 193.747L397.747 179.605C398.528 178.824 399.795 178.824 400.576 179.605L458.559 237.588C463.245 242.274 463.245 249.872 458.559 254.558Z",
    stroke: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "386.434",
    y: "188.09",
    width: "16",
    height: "4",
    rx: "2",
    transform: "rotate(-135 386.434 188.09)",
    fill: "white"
  }), React__default["default"].createElement("rect", {
    x: "366.371",
    y: "131.258",
    width: "32",
    height: "2",
    rx: "1",
    transform: "rotate(-90 366.371 131.258)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "357.622",
    y: "147.965",
    width: "64",
    height: "2",
    rx: "1",
    transform: "rotate(-90 357.622 147.965)",
    fill: "#0069C0"
  }), React__default["default"].createElement("rect", {
    x: "453.609",
    y: "242.537",
    width: "40",
    height: "4",
    rx: "2",
    transform: "rotate(-135 453.609 242.537)",
    fill: "#C2DBF0"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("filter", {
    x: "261.01",
    y: "302",
    width: "85.9311",
    height: "36",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    x: "366.382",
    y: "270",
    width: "107.116",
    height: "32",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    x: "541.625",
    y: "270",
    width: "84.6681",
    height: "32",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    x: "453.466",
    y: "270",
    width: "108.996",
    height: "36",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    x: "0.381836",
    y: "282",
    width: "107.116",
    height: "32",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  })), React__default["default"].createElement("filter", {
    x: "88.1233",
    y: "282",
    width: "139.646",
    height: "36",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React__default["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React__default["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), React__default["default"].createElement("feGaussianBlur", {
    stdDeviation: "6",
    result: "effect1_foregroundBlur"
  }))));
};

module.exports = SearchEmpty;
